export const AUTHORIZATION_ID_STORAGE_KEY = 'PO.authorizationId';
export const PARAM_CANCELED_VALUE = 'request canceled';
export const AUTHORIZATION_ERROR_PARAM = 'Error';
// Query params on the NIA return URL, e.g. /autorizace?Id={authId}&Result=1
export const AUTHORIZATION_ID_PARAM = 'Id';
export const AUTHORIZATION_RESULT_PARAM = 'Result';
export const AUTHORIZATION_RESULT_SUCCESS_VALUE = '1';
export const AUTHORIZATION_RESULT_FAILURE_VALUE = '0';
// Router navigation-state flag set when redirecting to the submission detail
// after an authorization that failed for a reason other than user cancellation.
export const AUTHORIZATION_FAILED_STATE_KEY = 'authorizationFailed';
export const AUTHORIZATION_CANCELLED_RETURN_URL_KEY =
	'authorizationCancelledReturnUrl';
